<script>
import datetimeCommons from "../mixins/datetimeCommons.vue";
import { getFormattedQuantity, getPriceByOriginPriceOrKgLt } from "../../shared/repositories/products/productsService";
import { formatDateTime } from "@/features/shared/utils/utils"
import printerCommons from "@/features/shared/mixins/printerCommons.vue";
import { getOrderByUuid } from "@/features/shared/repositories/orders/ordersService";
import { getCommentForTicket , getTextLeftForAuditsMovements } from '@/features/shared/repositories/closeCashboxes/closeCashboxesService'
import { ORDER_STATUS } from "@/features/shared/utils/orderStatuses"
import instanceCommons from "@/mixins/instanceCommons.vue";

export default {
    mixins: [datetimeCommons, printerCommons, instanceCommons],
    data() {
        return {
            ESC: "\x1B", // ESC byte in hex notation
      
        }
    },
    methods: {
        replaceSpecialChars(text) {
            const replacements = {
                'á': 'a', 'é': 'e', 'í': 'i', 'ó': 'o', 'ú': 'u',
                'Á': 'A', 'É': 'E', 'Í': 'I', 'Ó': 'O', 'Ú': 'U',
                'ñ': 'n', 'Ñ': 'N',
                'ü': 'u', 'Ü': 'U',
            };

            return text.replace(/[áéíóúÁÉÍÓÚñÑüÜ]/g, function (match) {
                return replacements[match];
            });
        },
        generatePartialOrReprintTicket(order, products, dest, isReprint) {
            const reprintText = isReprint ? 'REIMPRESION' : ''
            const header = order.isTableOrder ? (order.tableName || `Mesa ${order.tableId}`) : dest + " " + order.origin;
            return this.generateTicket([
                this.generateSection([
                    this.addHeader(reprintText),
                    this.addHeader(header),
                    this.setFontCenter(this.setFontBold(this.addOrderId(order)))
                ]),
                this.addSummary(order),
                this.addProducts(products),
                ...(order.comment !== '' ? [this.addOrderComment(order.comment ) + "\n"]: []),
            ]);
        },
        generateTestTicket(origin) {

            return this.generateTicket([
                this.generateSection([
                    this.addHeader('IMPRESION DE TEST')
                ]),
                this.addSummary(null),
                this.generateSection([
                    this.setFontBold('TEXTO NEGRITA'), "\n",
                    this.setFontDoubleWidth('TEXTO DOBLE NEGRITA'), "\n",
                    this.setFontCenter('TEXTO CENTRADO'), "\n",
                    this.setFontDoubleHeight('DOBLE ALTO'), "\n",
                    this.setFontLargeAndBold('DOBLE'), "\n",

                ]),
                this.generateSection([
                    this.addFreeText(origin)
                ]),
            ]);
        },

        generateCloseOrderTicket(order) {
            const products = this.getProductRowsToPrint(order);

            return this.generateTicket([
                this.generateSection([
                    // this.addLogo(),
                    this.addHeader(`${order.tableName || `Mesa ${order.tableId}`}`),
                    this.setFontCenter(this.setFontBold(this.addOrderId(order)))

                ]),
                this.addSummary(order),
                this.generateSection([
                    this.addProducts(products),
                    this.addTotal(order),
                ]),
                ...(order.comment !== '' ? [this.addOrderComment(order.comment)] : []),
                this.generateSection([
                    this.addLineBreak()
                ])
            ]);
        },
        generateCashBoxTicket(isPartial = false) {
            const fiscalData = JSON.parse(localStorage[`userDataPDV_${this.shopCode}`]) 
            let cashBox;

            if (isPartial) {
                cashBox = this.$store.getCashBox;
            } else {
                [cashBox] = this.$store.getCashBox;
            }
            // Header principal
            const mainHeader = this.generateSection([
                this.addHeader(isPartial ? 'PARCIAL CAJA' : 'CIERRE DE CAJA'),
            ]);

            // Datos genéricos
            const genericDataLines = [];


            genericDataLines.push(
                { textLeft: "Fecha de apertura:", textRight: formatDateTime(cashBox.openDate) },
            );
            if (!isPartial) {
                genericDataLines.push(
                    { textLeft: "Fecha de cierre:", textRight: formatDateTime(cashBox.closeDate) },
                );
            }
            genericDataLines.push(
                { textLeft: "Razon social:", textRight: fiscalData?.legalName },
                { textLeft: "Operador:", textRight: this.$store.getAuthUser ? this.$store.getAuthUser.user.name : JSON.parse(localStorage["currentUserData"]).user.name },
                { textLeft: "Efectivo en caja apertura:", textRight: this.$filters.currency(cashBox.lastCloseAmount) },
                { textLeft: "Efectivo declarado en apertura:", textRight: this.$filters.currency(cashBox.declaredAmount) },
            );
            if (!isPartial) {
                genericDataLines.push(
                    { textLeft: "Efectivo en cierre de caja:", textRight: this.$filters.currency(cashBox.closeAmount) },
                    { textLeft: "Diferencia encontrada en apertura:", textRight: this.$filters.currency(cashBox.declaredAmount - cashBox.lastCloseAmount) },
                    { textLeft: "Diferencia encontrada en cierre:", textRight: this.$filters.currency(cashBox.closeAmount - cashBox.totalAmountOfCashboxMovements) }
                );
            }else{
                genericDataLines.push(
                    { textLeft: "Efectivo en caja:", textRight: this.$filters.currency(cashBox.totalAmountOfCashboxMovements) },
                );
            }
            const secondHeader = this.addHeader('DATOS GENERICOS')
            const genericData = this.generateSection([
                this.generateLines(genericDataLines),
            ]);

            // Totales de venta
            const thirdHeader = this.addHeader('TOTALES DE VENTAS')
            const amounts = [
            { textLeft: "Total de comandas:", textRight: this.$filters.currency(cashBox.totalOrderAmount) },
            { textLeft: "Total de anulaciones de comandas:", textRight: this.$filters.currency(cashBox.totalAmountVoided) },
            ]
            if(this.isArgentinaInstance){
                amounts.push({ textLeft: "Total de Ventas:", textRight: this.$filters.currency(cashBox.totalSaleAmount) });
                amounts.push({ textLeft: "Total de Notas de credito:", textRight: this.$filters.currency(cashBox.totalAmountVoidedNT) });

            }
            const totals = [
                    { textLeft: "Cantidad de comandas:", textRight: `${cashBox.totalOrders}` },
                    { textLeft: "Cantidad de anulaciones de comandas:", textRight: `${cashBox.totalVoided}` },
            ]
            if(this.isArgentinaInstance){
                totals.push({ textLeft: "Cantidad de Ventas:", textRight: `${cashBox.totalSales}` });
                totals.push({ textLeft: "Cantidad de Notas de credito:", textRight: `${cashBox.totalVoidedNT}` });

            }
            const guests = [
                { textLeft: "Cubiertos", textRight: `${cashBox.totalGuests || 0}` }
            ];
            const salesTotals = this.generateSection([
                this.generateLines(amounts),
                this.addLineBreak(),
                this.generateLines(totals),
                this.addLineBreak(),
                this.generateLines(guests),
                this.addLineBreak(),
                this.generateLines([
                    { textLeft: "Total Vendido:", textRight: this.$filters.currency(cashBox.totalSold) },
                ]),
            ]);
         
            // Totales de ventas por medio de pago
            const fourthHeader = this.addHeader('TOTALES DE VENTAS POR MEDIO DE PAGO')

            const paymentLines = [
                { textLeft: "Efectivo:", textRight: this.$filters.currency(cashBox.totalCash) },
                { textLeft: "Tarjetas:", textRight: this.$filters.currency(cashBox.totalCard) }
            ];

            if (!this.isMexicoInstance && !this.isSpainInstance) {
                paymentLines.push({ textLeft: "QR:", textRight: this.$filters.currency(cashBox.totalQR) });
            }

            paymentLines.push({ textLeft: "Online:", textRight: this.$filters.currency(cashBox.totalOnline) });

            const paymentTotals = this.generateSection([
                this.generateLines(paymentLines),
                this.addLineBreak(),
                this.generateLines([
                    { textLeft: "Total:", textRight: this.$filters.currency(cashBox.totalCash + cashBox.totalCard + cashBox.totalQR + cashBox.totalOnline) },
                ]),
            ]);

            // Otros movimientos
            const fifthHeader = this.addHeader('OTROS MOVIMIENTOS')

            const otherMovements = this.generateSection([
                this.generateLines([
                    { textLeft: "Total Retiros:", textRight: this.$filters.currency(cashBox.totalWithdrawal) },
                    { textLeft: "Total Depositos:", textRight: this.$filters.currency(cashBox.totalDeposit) },
                ]),
                this.addLineBreak(),

            ]);


            const sixthHeader = this.addHeader('AUDITORIA POR MOVIMIENTO');
            const auditsMovementsData = cashBox.auditsMovements;

            const auditsMovements = this.generateSection(
                auditsMovementsData.map((item) =>
                    this.generateLines([
                        {
                            textLeft: `${getTextLeftForAuditsMovements(item)}`,
                            textRight: `${this.$filters.currency(item.amount)}`,
                            comment: getCommentForTicket(item),
                        },
                    ])
                ).concat(this.addLineBreak()) // Agregar un salto de línea al final
            );


            // Construcción final del ticket
            const ticket = this.generateTicket([
                mainHeader,
                secondHeader,
                genericData,
                thirdHeader,
                salesTotals,
                fourthHeader,
                paymentTotals,
                fifthHeader,
                otherMovements,
                sixthHeader,
                auditsMovements,
            ]);

            return ticket;
        },
        async generateVoidTicket(orderUuid) {
            const order = await getOrderByUuid(this.shopCode, orderUuid)
            const products = this.getProductRowsToPrint(order); 
            return this.generateTicket([
                this.addHeader("ANULACION"),

                this.generateSection([
                    this.addOrderId(order)
                ]),
                this.addSummary(order),
                this.generateSection([
                    this.addProducts(products),
                    this.addTotal(order)
                ]),
                this.addPaymentDetails(order),
                ...order.comment != '' ? this.addOrderComment(order.comment) : [],

                this.generateSection([
                    this.addExtraTicketLines()
                ])
            ]);
        },      
        parseXml(xml) {
            // Asegurar que las etiquetas auto-cerradas estén bien formadas
            xml = xml.replace(/<(\w+)\s+(center|left|right|row)(\s|>)/g, '<$1 $2="true"$3');

            // Reemplazar etiquetas auto-cerradas por tags abiertos/cerrados para simplificar el parser
            xml = xml.replace(/<(\w+)\s*\/>/g, '<$1></$1>');

            // Parsear XML
            return new DOMParser().parseFromString(xml, "text/xml");
        },
        getTicketToPrintFromXml(xml) {
            const xmlDoc = this.parseXml(xml);
            return Array.from(xmlDoc.getElementsByTagName("ticket"))
                .map(ticketNode => this.processTicket(ticketNode));
        },
        processTicket(ticketNode) {
            const sections = [];

            // Importante: el XML de billing puede traer <br/> fuera de <section>
            Array.from(ticketNode.childNodes).forEach(node => {
                if (node.nodeType !== Node.ELEMENT_NODE) return;

                const tag = node.tagName?.toLowerCase();
                if (tag === 'section') {
                    sections.push(this.processSection(node));
                    return;
                }

                if (tag === 'br') {
                    sections.push({
                        type: 'section',
                        elements: this.processText(node, 'br'),
                    });
                }
            });

            return {
                type: "ticket",
                sections,
            };
        },
        processSection(sectionNode) {
            return {
                type: "section",
                elements: Array.from(sectionNode.childNodes)
                    .flatMap(child => this.processSectionNode(child))
            };
        },
        processSectionNode(node) {
            if (node.nodeType !== Node.ELEMENT_NODE) return [];
            const tag = node.tagName.toLowerCase();
            const processors = {
                h1: () => this.processText(node, "h1"),
                h3: () => this.processText(node, "h3"),
                br: () => this.processText(node, "br"),
                qr: () => this.processText(node, "qr"), // Manejo del código QR
            };
            return processors[tag]?.call(this, node) || [];
        },
        processText(node, size) {
            // Reemplazos de texto en caso de marcadores especiales
            let text = node.textContent

            let alignment;
            let side;
            if (node.children.length > 1) {
                alignment = Array.from(node.children).map(child => ({
                    text: child.textContent,
                    place: child.attributes[0]?.name
                }));
            } else {
                if (node.tagName == 'qr') {
                    alignment = 'qr'
                    const url = node.textContent.trim();

                    return [{ alignment, url }];
                }
                // Cero o un solo hijo: devolvemos el texto completo
                alignment = text ? text : '';
                side = node.tagName == 'br' ? 'br' :
                    node.hasAttribute('left') ? 'left' :
                        node.hasAttribute('left') ? 'left' :
                            node.hasAttribute('right') ? 'right' : '';

            }
            return [{ alignment, size, side }];
        },

        formatBillTicket(element) {
            if (element.alignment === "qr") {
                return  this.generateQRCodeCommand(element.url);
            }
            if (Array.isArray(element.alignment)) {
                const leftItem = element.alignment.find(item => item.place === 'left');
                const rightItem = element.alignment.find(item => item.place === 'right');
                return this.generateLines([
                    {
                        textLeft:leftItem.text,
                        textRight: rightItem.text,
                    },
                ]) + "\n"
            } else{
                if (element.size === 'h1') {
                    return this.setFontCenter(this.setFontDoubleWidth(element.alignment)) + "\n";
                } else {
                    return element.alignment ? element.alignment + "\n" : this.addLineBreak();
                }
            }
        },
        generateBillingTicket(ticketXmlString) {
            if(!ticketXmlString) return
            const ticket = this.replaceSpecialChars(ticketXmlString)
            const [ticketObject] = this.getTicketToPrintFromXml(ticket);
            const sections = [];

            ticketObject.sections.forEach(section => {
                // Se mapea cada elemento de la sección usando formatBillTicket
                const sectionContent = section.elements.map(element => this.formatBillTicket(element));
                sections.push(this.generateSection(sectionContent));
            });
            // Se genera el ticket usando las secciones ya procesadas
            return this.generateTicket(sections, true);
        },
        async generatePaymentOrderTicketByOrderUuid(orderUuid, isReprint = false) {
            const order = await getOrderByUuid(this.shopCode, orderUuid);
            if(!order) {
                console.error("No se encontro la orden para imprimir el ticket");
                return
            }
            const headerTextReprint = isReprint ? "REIMPRESION " :''           
            const headerText = order.status === ORDER_STATUS.VOID ? "ANULACION" : null
            const headerTextTable = order.isTableOrder ? (order.tableName || `Mesa ${order.tableId}`) : null
            const products = this.getProductRowsToPrint(order); 
            const ticketSections = [
                ...(headerTextReprint ? [this.addHeader(headerTextReprint)] : []), // Agrega "REIMPRESION" solo si aplica
                ...(headerText ? [this.addHeader(headerText)] : []), // Agrega "ANULACION" solo si aplica
                ...(headerTextTable ? [this.addHeader(headerTextTable)] : []), // Agrega "MESA" solo si aplica

                this.generateSection([this.addOrderId(order)]),
                this.addSummary(order),
                this.generateSection([this.addProducts(products), this.addTotal(order)]),
                this.addPaymentDetails(order),
                ...(order.comment != '' ? [this.addOrderComment(order.comment)] : []),
                this.addExtraTicketLines(),
                ...(this.isMexicoInstance ? ['\n\n' + this.generateQRCodeCommand(`https://mx.bistrosoft.com/billViewer?InternalReference=${orderUuid}`, 6) + '\n\n'] : ['\n'])

            ];
            return this.generateTicket(ticketSections);
        },
        // Función para generar el código QR en formato ESC/POS
        generateQRCodeCommand(url,  moduleSize = 4) {
            let qrCodeData = "";

            // Centrar el QR
            qrCodeData += "\x1B\x61\x01"; // ESC a 1 = Alineación centrada

            // Seleccionar el modelo QR (model 2)
            qrCodeData += "\x1D\x28\x6B\x04\x00\x31\x41\x32\x00";

            // Establecer el tamaño del módulo QR (Aumentado a 8)
            qrCodeData += "\x1D\x28\x6B\x03\x00\x31\x43" + String.fromCharCode(moduleSize);

            // Nivel de corrección de errores (Mejorando a nivel M - 49)
            qrCodeData += "\x1D\x28\x6B\x03\x00\x31\x45\x31";

            // Definir datos del QR
            let qrDataLength = url.length + 3;
            qrCodeData += "\x1D\x28\x6B" + String.fromCharCode(qrDataLength & 0xFF, (qrDataLength >> 8) & 0xFF);
            qrCodeData += "\x31\x50\x30";
            qrCodeData += url; // Agregar URL del QR

            // Imprimir QR
            qrCodeData += "\x1D\x28\x6B\x03\x00\x31\x51\x30";

            // Restaurar alineación a la izquierda después del QR
            qrCodeData += "\x1B\x61\x00"; // ESC a 0 = Alineación a la izquierda

            return qrCodeData + '\n\n\n';
        },
        generateTicket(sections, isBillingTicket = false) {
            let content = this.ESC + "@\n";
            let isFirstLine = true;

            sections.forEach(section => {
                const isOnlyLineBreaks = typeof section === 'string' && section.trim() === '';

                if (!isFirstLine && !isOnlyLineBreaks) {
                    const separatorLine = this.isPrinter42Characters() ? "-----------------------------------------" : "------------------------------------------------";
                    content += this.ESC + "a" + "0" + separatorLine + "\n";
                }
                content += section;
                isFirstLine = false;
            });

            if (!isBillingTicket) {
                content += "\n\n";
            }
            content += this.ESC + "d" + "\x02" + this.ESC + "m";

            return content;
        },
        generateSection(lines) {
            let section = "";
            lines.forEach(line => {
                section += line;
            });
            return section;
        },
        addHeader(header) {
            return this.ESC + "a" + "1" + header + "\n\n";
        },

        // Traemos la configuracion del localStorage
        getSettingsLocalStorage(settingsKey) {
            const settings = localStorage.getItem(settingsKey);
            return settings ? JSON.parse(settings) : null;
        },
        addOrderId(order) {
            const settings = this.getSettingsLocalStorage("settingsPrint")
            if (!settings) return this.ESC + "a" + "1" + "C" + String(order.id).padStart(8, '0') + "\n\n";

            else if (settings?.printOrderNumber) {
                return this.ESC + "a" + "1" + "C" + String(order.id).padStart(8, '0') + "\n\n";
            } else {
                return ""
            }
        },
        addLogo() {
            return this.ESC + "a" + "1" + "{{LOGO}}\n\n"; // TODO ADV: De donde sacamos el logo???
        },
        addSummary(order) {
            let timestamp
            if(order){
                timestamp = order.lastUpdate
            } else {
                timestamp = Date.now();
            }
            let section = this.addLine(this.convertTimestampToDate(timestamp), (this.convertTimestampToHour(timestamp) + "\n"));
            if (order?.ticketNumber) {
                section += this.addLine("Numero de ticket", order.ticketNumber.toString()) + "\n";
            }
            return section;
        },
        addTotal(order) {
            return this.setFontCenter(this.setFontLargeAndBold("TOTAL $ " + order.amount.toFixed(2))) + "\n\n";
        },
        addProducts(products) {
            return products.join('\n') + "\n\n\n";
        },
        addFreeText(comment) {
            return this.ESC + "a" + "1" + this.replaceSpecialChars(comment) + "\n\n";
        },
        addOrderComment(comment) {
            return this.setFontCenter(this.setFontBold(this.replaceSpecialChars(comment))) + "\n\n";
        },
        addExtraTicketLines() {
            return this.ESC + "a" + "1" + 'Ticket no valido como factura' + "\n";
        },
        addPaymentDetails(order) {
            const payment = order.payments[0];
            switch (payment.paymentWay) {
                case "EFECTIVO":
                    return payment.paymentWay + "\n" +
                        "Entregado: $" + Number(payment.receivedPaidAmount).toFixed(2) + "\n" +
                        (this.isMexicoInstance ? "Cambio: $" : "Vuelto: $") + (Number(payment.receivedPaidAmount) - payment.amount).toFixed(2) + "\n";
                default:
                    return payment.paymentWay + "\n";
            }
        },
        getProductRowsToPrint(order) {
            let products = [];
            order.products.forEach(element => {
                const quantityAndName = this.replaceSpecialChars(getFormattedQuantity(element) + " " + element.name);
                const totalPrice = getPriceByOriginPriceOrKgLt(element);
                const priceAsString = `$ ${totalPrice.toFixed(2)}`;

                products.push(this.addLine(quantityAndName, priceAsString));

                if (element.comment) {
                    products.push(this.addLine(`   ${this.replaceSpecialChars(element.comment)}`));
                }
                if (element.discountByPercentage) {
                    const label = `   - DESC. POR PRODUCTO (${element.discountByPercentage}%)`;
                    const discountPrice = `$ -${(totalPrice * (element.discountByPercentage / 100)).toFixed(2)}`;
                    products.push(this.addLine(label, discountPrice));
                }
                if (element.discountByAmount) {
                    const label = `   - DESCUENTO FIJO`;
                    const totalDiscount = element.discountByAmount * element.quantity;
                    const discountPrice = `$ -${totalDiscount.toFixed(2)}`;
                    products.push(this.addLine(label, discountPrice));
                }
            });
            return products;
        },
        addLine(label, price) {
            if (!price) {
                return label;
            }

            const lineLength = this.isPrinter42Characters() ? 42 : 48;
            const priceLength = price.length + 1 // Espacio para el precio (incluye margen)
            const maxLabelLength = lineLength - priceLength // Espacio máximo por linea para el label

            let formattedText = []
            let lines = []

            //  Tomar los primeros caracteres de la primera línea
            const firstLine = label.substring(0, maxLabelLength)
            const remainingText = label.substring(maxLabelLength) // Lo que sobra

            // Alinear el precio en la primera línea
            const spacesNeeded = Math.max(0, lineLength - (firstLine.length + price.length))
            formattedText.push(firstLine + " ".repeat(spacesNeeded) + price)

            // Dividir el resto del texto en bloques de `maxLineLength` caracteres
            for (let i = 0; i < remainingText.length; i += maxLabelLength) {
                lines.push(remainingText.substring(i, i + maxLabelLength))
            }

            // Agregar las líneas restantes al texto formateado
            formattedText = formattedText.concat(lines)

            return formattedText.join("\n")
        },
        generateLines(lines) {
            return lines
                .map(({ textLeft, textRight, comment }) => {
                    const mainLine = this.addLine(textLeft, textRight);
                    const commentLine = comment ? `   ${this.replaceSpecialChars(comment)}` : "";
                    return commentLine ? `${mainLine}\n${commentLine}` : mainLine;
                })
                .join("\n");
        },
        addLineBreak() {
            return "\n\n";
        },
        isPrinter42Characters() {
            // Obtener tipo de impresora seleccionado por el usuario
            const selectedPrinterType = localStorage.getItem("selectedPrinterType");
            if (selectedPrinterType === '42') {
                return true; // SAM4S necesita menos caracteres
            }            
            // Si no hay configuración, usar valor por defecto
            return false;
        }

    }
}
</script>